import { Switch, Route, useHistory, useLocation } from "react-router-dom";
import SectionHeader from "components/SectionHeader";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@material-ui/core";
import CertForm from "./Certificates/Form";
import { Button } from "components/Forms/StyledComponents";
import CertList from "./Certificates/List";
import SectionTabs from "components/SectionTabs";
import { useState } from "react";
import Accounts from "./Accounts/List";
import AccountForm from "./Accounts/Form";

export default function Page() {
  const { t } = useTranslation("smime");
  const { tabs, selectedTab, changeTab } = useTab();

  return (
    <Switch>
      <>
        <SectionHeader
          title={t("sidebar:certificates")}
          sideBtn={<ActionBtn currentTab={selectedTab} />}
        >
          <Typography>{t("description")}</Typography>
        </SectionHeader>

        <Switch>
          <Route path="/smime-certs/new" exact>
            <CertForm />
          </Route>

          <Route path="/smime-certs/accounts/new" exact>
            <AccountForm action="new" />
          </Route>

          <Route path="/smime-certs/accounts/:email/edit">
            <AccountForm action="edit" />
          </Route>

          <Route path="/smime-certs">
            <SectionTabs
              tabs={tabs}
              onClick={changeTab}
              showTab={selectedTab}
            />

            <Box display={selectedTab === "certificates" ? "inline" : "none"}>
              <CertList />
            </Box>

            <Box display={selectedTab === "accounts" ? "inline" : "none"}>
              <Accounts />
            </Box>
          </Route>
        </Switch>
      </>
    </Switch>
  );
}

function useTab() {
  const { t } = useTranslation("smime");
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  const [selectedTab, setSelectedTab] = useState<"certificates" | "accounts">(
    searchParams.get("tab") === "accounts" ? "accounts" : "certificates"
  );

  const tabs = [
    {
      id: "certificates",
      label: t("tab.certs"),
    },
    {
      id: "accounts",
      label: t("tab.accounts"),
    },
  ];

  function changeTab(newTab: string) {
    searchParams.set("tab", newTab);
    setSelectedTab(newTab as "certificates" | "accounts");
  }

  return { tabs, selectedTab, changeTab };
}

function ActionBtn({
  currentTab,
}: {
  currentTab: "certificates" | "accounts";
}) {
  const { t } = useTranslation("smime");
  const history = useHistory();
  const { pathname } = useLocation();
  const isOnForm = pathname.includes("/new") || pathname.includes("/edit");

  let wording = t("addCert");
  let onClickPath = "/smime-certs/new";
  if (isOnForm) {
    wording = t("common:backToList");
    onClickPath = "/smime-certs";
  } else if (currentTab === "accounts") {
    wording = t("addAccount");
    onClickPath = "/smime-certs/accounts/new";
  }

  return (
    <Button
      wording={wording}
      onClick={() => {
        history.push(onClickPath);
      }}
    />
  );
}
